export default {"src":"/_next/static/media/cozumortagi-big-mobile.371965b2.svg","height":99,"width":241};